import { FLOODLIGHT_INSTALLATION_HELP_URL } from "../../../../native/geeni/js/constants";

const installationInstructions = {
  powerDevice: {
    currentStep: "powerDevice",
    nextStep: "confirmPairingMode",
    nextStepName: "categoryInstructions",
    prevStepName: "https://return-to-app",
    headerOverridingClass: "background-gray",
    resource: require("@/assets/categories/floodlight/floodlight_power.png"),
    resourceType: "image",
    primaryTx: "categories.floodlight.powerDevice.title",
    secondaryTx: "categories.floodlight.powerDevice.subtitle",
    continueButtonTx: "common.continue",
    alternateNextStep: {
      link: FLOODLIGHT_INSTALLATION_HELP_URL,
      titleTx: "categories.floodlight.pairingInstructions",
    },
  },
  confirmPairingMode: {
    currentStep: "confirmPairingMode",
    prevStep: "powerDevice",
    prevStepName: "categoryInstructions",
    headerOverridingClass: "background-gray",
    resource: require("@/assets/categories/floodlight/floodlight_pairing_mode.png"),
    resourceType: "image",
    primaryTx: "categories.floodlight.confirmPairingMode.title",
    secondaryTx: "categories.camera.confirmPairingMode.subtitle",
    isLastPage: true,
    lastPageExitUrl: "https://www.exit-installation-instructions-flow",
    primaryActionKey: "chooseProvider",
    continueButtonTx: "common.continue",
    alternateNextStep: {
      titleTx: "categories.floodlight.stepsToReset",
      nextStep: "resetDevice",
      nextStepName: "categoryInstructions",
      lastStep: "confirmPairingMode",
    },
  },
  resetDevice: {
    headerIcon: "closeBlack",
    prevStep: "powerDevice",
    prevStepName: "categoryInstructions",
    currentStep: "resetDevice",
    nextStep: "confirmPairingMode",
    nextStepName: "categoryInstructions",
    headerOverridingClass: "background-gray",
    headerTitleTx: "categories.floodlight.stepsToReset",
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: "image",
          resource: require("@/assets/categories/floodlight/reset_floodlight_step_1.png"),
          primaryTx: "categories.floodlight.resetDevice.step1.title",
          secondaryTx: "categories.floodlight.resetDevice.step1.subtitle",
        },
        {
          resourceType: "image",
          resource: require("@/assets/categories/floodlight/reset_floodlight_step_2.png"),
          primaryTx: "categories.floodlight.resetDevice.step2.title",
          secondaryTx: "categories.floodlight.resetDevice.step2.subtitle",
        },
        {
          resourceType: "image",
          resource: require("@/assets/categories/floodlight/reset_floodlight_step_3.png"),
          primaryTx: "categories.floodlight.resetDevice.step3.title",
          secondaryTx: "categories.floodlight.resetDevice.step3.subtitle",
        },
      ],
    },
  },
};

export default installationInstructions;
